import React from 'react';
import { motion } from 'framer-motion';
import styles from './FeatureThird.module.css';
import icon from '../../../images/Features/a-cheerful-group-of-friends-playing-playstation----Photoroom.webp';

const FeatureThird = ({ openModal }) => {
    return (
        <div style={{ overflow: 'hidden' }}>
            <motion.div
                initial={{opacity: 0, x: 200}}
                whileInView={{opacity: 1, x: 0}}
                transition={{duration: 1}}
                viewport={{once: true}}
                className={styles.container}
            >
                <div className={styles.row}>
                    <img
                        className={styles.first_img}
                        src={icon}
                        alt="group-of-friends"
                    />
                    <div className={styles.column}>
                        <h2>
                            Збирайтеся з друзями <span style={{ color: 'red' }}>грати разом</span>!
                        </h2>
                        <img
                            className={styles.second_img}
                            src={icon}
                            alt="group-of-friends"
                        />
                        <div className={styles.titles}>
                            <h3>
                                Не пропустіть можливість весело провести час!
                            </h3>
                            <p>
                                Дізнайтеся, хто з вас справжній чемпіон на трасі, а хто - майстер ефектних Fatality.
                            </p>
                            <button onClick={() => openModal()} className={styles.btn}>
                                Отримати консоль
                            </button>
                        </div>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default FeatureThird;
